import { render, staticRenderFns } from "./importResult.vue?vue&type=template&id=021d7685&scoped=true&"
import script from "./importResult.vue?vue&type=script&lang=js&"
export * from "./importResult.vue?vue&type=script&lang=js&"
import style0 from "./importResult.vue?vue&type=style&index=0&id=021d7685&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d7685",
  null
  
)

export default component.exports